export default "5ef4585fe557a967.svg"